import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import './index.styles.css'
export const EmptyStateLayout = ({ children }: React.PropsWithChildren) => {
  const animationRef = React.useRef<HTMLDivElement | null>(null)
  useUnsafeEffect(() => {
    setTimeout(
      () =>
        animationRef.current
          ? (animationRef.current.className = `${animationRef.current.className.replace(
              'EmptyStateLayout_initialOpacity',
              ''
            )} ${'EmptyStateLayout_transition'}`)
          : null,
      100
    )
  }, [])

  return (
    <Box
      width="full"
      alignItems="center"
      gap="s80"
      className={'EmptyStateLayout_initialOpacity'}
      ref={animationRef}
    >
      {children}
    </Box>
  )
}
